import { render } from "./TaskDelete.vue?vue&type=template&id=99a5fa5c&scoped=true"
import script from "./TaskDelete.vue?vue&type=script&lang=js"
export * from "./TaskDelete.vue?vue&type=script&lang=js"

import "./TaskDelete.vue?vue&type=style&index=0&id=99a5fa5c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-99a5fa5c"

export default script